export default {
  verificaTipoChamada(tipoChamada) {
    if (tipoChamada === 'Saida') {
      return 'S.'
    }
    if (tipoChamada === 'ChamadaFila') {
      return 'E.F.'
    }
    return 'E.O.'
  },

  verificaTipoChamadaTooltip(tipoChamada) {
    if (tipoChamada === 'Saida') {
      return 'Saída'
    }
    if (tipoChamada === 'ChamadaFila') {
      return 'Entrada Fila'
    }
    return 'Entrada Operador'
  },
  verificaFila(dadoRelatorio) {
    if (typeof dadoRelatorio.fila !== 'undefined') {
      return dadoRelatorio.fila
    }
    return ''
  },
  verificaDestino(dadoRelatorio) {
    if (typeof dadoRelatorio.ramalLogado !== 'undefined') {
      return dadoRelatorio.ramalLogado
    }
    return dadoRelatorio.numeroDestino
  },

  verificaCentroDeCusto(dadoRelatorio) {
    if (typeof dadoRelatorio.centroDeCusto !== 'undefined') {
      return `${dadoRelatorio.centroDeCusto.codigo}`
    }
    return ''
  },

  verificaCentroDeCustoTooltip(dadoRelatorio) {
    if (typeof dadoRelatorio.centroDeCusto !== 'undefined') {
      return `${dadoRelatorio.centroDeCusto.description}`
    }
    return ''
  },

  verificaStatusChamada(statusChamada) {
    const statusCallObject = {
      ['atendida']: 'Atendida',
      ['ocupado']: 'Ocupado',
      ['acessoNegado']: 'Acesso Negado',
      ['naoAtendida']: 'Não Atendida',
      ['error']: 'Erro',
      ['outros']: 'Outros',
      ['pending']: 'Pendente',
      ['TRANSFERENCIA']: 'Transferência',
      ['DESLIGADO PELO OPERADOR']: 'Desligado pelo Operador',
      ['DESLIGADO PELA ORIGEM']: 'Desligado pela Origem',
      ['ATENDIDA']: 'Atendida',
      ['NÃO ATENDIDA']: 'Não Atendida',
    }
    return statusCallObject[`${statusChamada}`]
  },
}
